{
  "moreLikely": "Plus probable",
  "lessLikely": "Moins probable",
  "yearCompletion": "La réalisation de l'objectif est probable dans ",
  "years": " {{years}} ans",
  "adjustNote": "Ajustez vos contributions initiales et mensuelles ci-dessous pour voir les projections mises à jour",
  "frequency": "fréquence"
}
